// extracted by mini-css-extract-plugin
module.exports = {"vehicleCardContainer":"az_jYb","vehicleCardDisplayName":"az_kYb","vehicleInfoContainer":"az_lYb","linkText":"az_mYb","vehiclesListContainer":"az_nYb","infoText":"az_oYb"};